import { createSelector } from "reselect";
import moment from "moment";
import _ from "lodash";

export const selectWeekCount = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;
    return RosterReducer.weekCount;
};

export const selectWeekStart = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;
    return RosterReducer.weekStart;
};

export const selectIsLocked = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;
    return RosterReducer.isLocked;
};

export const selectRawJobpacks = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;
    if (RosterReducer.rawJobpacks) {
        let jps = RosterReducer.rawJobpacks;
        let rawJobpacks = {};
        Object.keys(jps).map((y) => {
            Object.keys(jps[y]).map((m) => {
                Object.keys(jps[y][m]).map((ts) => {
                    let profile = jps[y][m][ts];
                    if (
                        profile.profile.deleted === false ||
                        profile.profile.deleted === undefined
                    )
                        _.assign(rawJobpacks, { [ts]: jps[y][m][ts] });
                    return null;
                });
                return null;
            });
            return null;
        });
        return rawJobpacks;
    } else return false;
};

export const selectArrangedJobpacksFromStore = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;

    return RosterReducer.arrangedJobpacks;
};

export const selectClickedEventSegment = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;
    return RosterReducer.clickedEventSegment;
};

export const selectSelectedJobpackID = ({ JobPackManager_reducer }) => {
    const { RosterReducer } = JobPackManager_reducer;
    return RosterReducer.selectedJobpackID;
};

export const selectWeekDayStrings = createSelector(
    [selectWeekStart, selectWeekCount],
    (weekStart, weekCount) => {
        const weekDays = [];

        for (let i = 0; i < weekCount * 7; ++i) {
            const date = moment(weekStart).add(i, "days");
            const dateString = date.format("ddd Do MMM");
            weekDays.push(dateString);
        }

        return weekDays;
    }
);

export const selectNextWeekStart = createSelector(
    [selectWeekStart],
    (weekStart) => {
        const nextWeekStart = moment(weekStart).add(1, "week").toDate();
        return nextWeekStart;
    }
);

export const selectPreviousWeekStart = createSelector(
    [selectWeekStart],
    (weekStart) => {
        const previousWeekStart = moment(weekStart).add(-1, "week").toDate();
        return previousWeekStart;
    }
);

export const getMomentFromDateString = (dateString) => {
    return moment(dateString, "DD-MM-YYYY");
};

export const getDateStringFromMoment = (momentObject) => {
    return momentObject.format("DD-MM-YYYY").toString();
};

function getJobpackCellPositions(rowCount, weekCount, dayArray) {
    const rowsArray = JSON.parse(
        JSON.stringify(
            new Array(rowCount).fill(new Array(weekCount * 7).fill(false))
        )
    );

    for (let row = 0; row < rowCount; ++row) {
        let candidateIndex = false;
        let startingIndex = false;
        let pushDown = [];

        for (let i = 0; i < dayArray.length; ++i) {
            if (
                dayArray[i].length > 0 &&
                typeof dayArray[i][row] !== "undefined"
            ) {
                candidateIndex = dayArray[i][row];
                startingIndex = i;

                if (candidateIndex !== false && startingIndex !== false) {
                    for (let i = 0; i < dayArray.length; ++i) {
                        if (dayArray[i].length > row + 1) {
                            if (dayArray[i][row + 1] === candidateIndex) {
                                pushDown.push(candidateIndex);
                            }
                        }
                    }
                }
            } else if (dayArray[i].length === 0) {
                dayArray[i] = new Array(rowCount).fill(false);
            }
        }

        pushDown = [...new Set(pushDown)];

        for (let i = 0; i < dayArray.length; ++i) {
            for (let j = 0; j < pushDown.length; ++j) {
                const pushDownIndex = pushDown[j];

                if (
                    dayArray[i][row] === pushDownIndex &&
                    Array.isArray(dayArray[i])
                ) {
                    dayArray[i].splice(row, 0, false);
                }
            }
        }
    }

    for (let i = 0; i < rowsArray.length; ++i) {
        for (let j = 0; j < rowsArray[i].length; ++j) {
            if (typeof dayArray[j][i] !== "undefined") {
                rowsArray[i][j] = dayArray[j][i];
            } else {
                rowsArray[i][j] = false;
            }
        }
    }

    return rowsArray;
}

export const selectArrangedJobpacksFromRawJobpacks = createSelector(
    [selectRawJobpacks, selectWeekStart, selectWeekCount],
    (rawJobpacks = false, weekStart, weekCount) => {
        if (
            rawJobpacks === false ||
            typeof rawJobpacks === "undefined" ||
            rawJobpacks === null
        ) {
            return [];
        }

        const jobpacks = Object.entries(rawJobpacks).map(([key, value]) => {
            return {
                uid: key,
                timestamp: _.get(value, "profile.timestamp") || null,
                status: _.get(value, "profile.status") || null,
                s_start_date: _.get(value, "profile.start_date") || null,
                s_end_date: _.get(value, "profile.end_date") || null,
                start_date: moment(
                    _.get(value, "profile.start_date") || null,
                    "DD-MM-YYYY"
                ),
                end_date: moment(
                    _.get(value, "profile.end_date") || null,
                    "DD-MM-YYYY"
                ),
            };
        });

        const weekStartMoment = moment(weekStart);
        const dayArray = [];
        let rowCount = 0;
        for (let i = 0; i < weekCount * 7; ++i) {
            dayArray.push([]);
            const currentDay = moment(weekStartMoment).add(i, "days");
            for (let jp = 0; jp < jobpacks.length; ++jp) {
                const { start_date, end_date } = jobpacks[jp];

                if (currentDay >= start_date && currentDay <= end_date) {
                    dayArray[i].push(jp);

                    if (dayArray[i].length > rowCount) {
                        rowCount = dayArray[i].length;
                    }
                }
            }
        }

        if (rowCount === 0) {
            return [];
        }

        const cellPositions = getJobpackCellPositions(
            rowCount,
            weekCount,
            dayArray
        );

        const jobpackIndices = {};
        for (let row = 0; row < cellPositions.length; ++row) {
            for (let day = 0; day < cellPositions[row].length; ++day) {
                const index = cellPositions[row][day];

                if (
                    index !== false &&
                    typeof jobpackIndices[index] === "undefined"
                ) {
                    jobpackIndices[index] = {
                        startIndex: day,
                        row: row,
                        endIndex: day,
                    };
                } else if (index !== false) {
                    jobpackIndices[index].endIndex++;
                }
            }
        }

        let result = Object.keys(jobpackIndices).reduce((acc, curr) => {
            acc[jobpacks[curr].uid] = jobpackIndices[curr];
            return acc;
        }, {});

        result = Object.keys(result).reduce((acc, curr) => {
            const startDate = _.get(rawJobpacks[curr], "profile.start_date");
            const endDate = _.get(rawJobpacks[curr], "profile.end_date");
            const status = _.get(rawJobpacks[curr], "profile.status");
            const timestamp = _.get(rawJobpacks[curr], "profile.timestamp");
            const startDiff = getMomentFromDateString(startDate).diff(
                weekStartMoment,
                "days"
            );
            const endDiff = getMomentFromDateString(endDate).diff(
                weekStartMoment,
                "days"
            );

            acc[curr] = {
                ...result[curr],
                status,
                timestamp,
                startIndex: startDiff,
                endIndex: endDiff,
                startDate,
                endDate,
                uid: curr,
            };

            return acc;
        }, {});

        return result;
    }
);

export const selectRowCount = createSelector(
    [selectArrangedJobpacksFromStore, selectWeekCount],
    (arrangedJobpacks = false, weekCount) => {
        const arrangedJobpacksArray = Object.entries(arrangedJobpacks).map(
            ([key, value]) => ({
                key,
                ...value,
            })
        );
        const rowCounts = [];
        for (let i = 0; i < weekCount * 7; ++i) {
            let currentRowCount = 0;
            for (let jp = 0; jp < arrangedJobpacksArray.length; ++jp) {
                const { startIndex, endIndex } = arrangedJobpacksArray[jp];

                if (startIndex <= i && endIndex >= i) {
                    currentRowCount++;
                }
            }

            rowCounts.push(currentRowCount);
        }

        let rowCount = 0;

        arrangedJobpacksArray.map(({ row }) => {
            if (row > rowCount) {
                rowCount = row;
            }

            return null;
        });

        rowCount++;

        rowCounts.map((e) => {
            if (e > rowCount) {
                rowCount = e;
            }

            return null;
        });

        return rowCount;
    }
);

const colours = [
    "239, 83, 80",
    "236, 64, 122",
    "171, 70, 187",
    "126, 87, 194",
    "92, 107, 192",
    "66, 165, 245",
    "40, 182, 246",
    "37, 197, 218",
    "38, 166, 154",
    "102, 187, 106",
    "156, 204, 101",
    "212, 225, 87",
    "255, 238, 88",
    "255, 201, 40",
    "255, 167, 37",
    "255, 112, 67",
];
export const selectArrangedJobpacksAsArray = createSelector(
    [selectArrangedJobpacksFromStore],
    (arrangedJobpacks) => {
        return Object.keys(arrangedJobpacks).map((e) => {
            const int = parseInt(e);
            const colour = colours[int % colours.length];
            return {
                uid: e,
                ...arrangedJobpacks[e],
                colour,
            };
        });
    }
);

export const selectSelectedJobpackProfile = createSelector(
    [selectSelectedJobpackID, selectRawJobpacks],
    (jobpackID, rawJobpacks) => {
        return _.get(rawJobpacks, `${jobpackID}.profile`) || false;
    }
);

export const selectJobpackProfile = (jobpackID) =>
    createSelector([selectRawJobpacks], (rawJobpacks) => {
        return _.get(rawJobpacks, `${jobpackID}.profile`) || false;
    });
